import React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Cards } from '../../../components/cards/frame/cards-frame';
import Heading from '../../../components/heading/heading';
import { carAmigoLogin } from '../../../redux/carImport/carAmigo/actionCreator';

const CarAmigoLogin = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { authLoading } = useSelector(state => {
    return {
      authLoading: state.carAmigo.authLoading,
    };
  });
  const handleSubmit = values => dispatch(carAmigoLogin(values.email, values.password));
  return (
    <Row justify="center">
      <Col sm={24} lg={12} md={16}>
        <Cards headless>
          <div className="auth-contents">
            <Form name="car-amigo-login" form={form} onFinish={handleSubmit} layout="vertical">
              <Heading as="h3">Login to CarAmigo</Heading>
              <Form.Item
                name="email"
                rules={[
                  { message: 'Please enter your email', required: true },
                  { type: 'email', message: 'Please enter valid email' },
                ]}
                label="Email Address"
              >
                <Input placeholder="Enter email address" />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[{ message: 'Please enter your password', required: true }]}
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>
              <Form.Item>
                <Button
                  className="btn-signin"
                  htmlType="submit"
                  style={{ backgroundColor: '#155BDC', color: '#fff' }}
                  size="large"
                  disabled={authLoading}
                >
                  {authLoading ? 'Loading...' : 'Sign In'}
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Cards>
      </Col>
    </Row>
  );
};

export default CarAmigoLogin;
